import React from "react";
import styled from "styled-components";

import { Panel } from "@workboard/wobo-ui";

import Term from "./Term";
import { useTranslation } from "react-i18next";

const Section = styled("section")``;

const Teams = ({ className, teams }) => {
  const { t } = useTranslation();
  return (
    <Panel as={Section} className={className}>
      <Term
        title={t("Total Functional Teams")}
        helperText={t("This is the number of functional teams (teams part of the org chart).")}
      >
        {teams}
      </Term>
    </Panel>
  );
}

export default styled(Teams)``;
